import React from 'react';
import routes from '@/config/routes';
import { getCommonRoutes } from './commonRoutes';
import { PrivateRoute } from './PrivateRoute';

export const getAdminRoutes = (): React.ReactElement[] => {
  const ADM_GigListPage = React.lazy(() => import('@/pages/admin/gig-list'));
  const ADM_GigDetail = React.lazy(() => import('@/pages/admin/gig-detail'));
  const ADM_GigCreate = React.lazy(() => import('@/pages/admin/gig-create'));
  const ADM_GigCampaignPage = React.lazy(() => import('@/pages/admin/gig-campaign'));
  const ADM_CourseBuilderPage = React.lazy(() => import('@/pages/admin/course-builder-list'));
  const ADM_CourseBuilderDetail = React.lazy(() => import('@/pages/admin/course-builder-form'));
  const ADM_ClassBuilderPage = React.lazy(() => import('@/pages/admin/class-builder-list'));
  const ADM_ClassBuilderCreatePage = React.lazy(() => import('@/pages/admin/class-builder-create'));
  const ADM_ClassBuilderEditPage = React.lazy(() => import('@/pages/admin/class-builder-edit'));
  const ADM_Permissions = React.lazy(() => import('@/pages/admin/permissions'));
  const ADM_GigPreview = React.lazy(() => import('@/pages/admin/gig-preview'));
  const ADM_ESignDocument = React.lazy(() => import('@/pages/admin/esigndocuments'));
  const ADM_FeaturedGigsPage = React.lazy(() => import('@/pages/admin/featured-gigs'));
  const ADM_PayRates = React.lazy(() => import('@/pages/admin/pay-rates'));
  const ADM_Community = React.lazy(() => import('@/pages/admin/community'));
  const ADM_SERVICE_PROVIDERS = React.lazy(() => import('@/pages/admin/service-providers'));
  const ADM_FRAUD_REVIEW_GROUPS = React.lazy(() => import('@/pages/admin/fraud-review-groups'));

  const items: React.ReactElement[] = [
    <PrivateRoute
      key={`${routes.admin.gig.preview}:gigId/country/:countryId/detail`}
      path={`${routes.admin.gig.preview}:gigId/country/:countryId/detail`}
      component={ADM_GigPreview}
    />,
    <PrivateRoute key={routes.admin.campaign.form} path={routes.admin.campaign.form} component={ADM_GigCampaignPage} />,
    <PrivateRoute key={routes.admin.gig.form} path={routes.admin.gig.form} component={ADM_GigDetail} />,
    <PrivateRoute key={routes.admin.gig.list} path={routes.admin.gig.list} component={ADM_GigListPage} />,
    <PrivateRoute key={routes.admin.newgig} path={routes.admin.newgig} component={ADM_GigCreate} />,

    <PrivateRoute
      key={`${routes.admin.course.list}/:clientId/:courseId`}
      path={`${routes.admin.course.list}/:clientId/:courseId`}
      component={ADM_CourseBuilderDetail}
    />,
    <PrivateRoute key={routes.admin.course.list} path={routes.admin.course.list} component={ADM_CourseBuilderPage} />,
    <PrivateRoute
      key={routes.admin.class.create}
      path={routes.admin.class.create}
      component={ADM_ClassBuilderCreatePage}
    />,
    <PrivateRoute key={routes.admin.class.edit} path={routes.admin.class.edit} component={ADM_ClassBuilderEditPage} />,
    <PrivateRoute key={routes.admin.class.list} path={routes.admin.class.list} component={ADM_ClassBuilderPage} />,
    <PrivateRoute key={routes.admin.community.index} path={routes.admin.community.index} component={ADM_Community} />,
    <PrivateRoute
      key={routes.admin.permission.index}
      path={routes.admin.permission.index}
      component={ADM_Permissions}
    />,
    <PrivateRoute
      key={routes.admin.agents.esignDocuments}
      path={routes.admin.agents.esignDocuments}
      component={ADM_ESignDocument}
    />,
    <PrivateRoute key={routes.admin.refer.payRates} path={routes.admin.refer.payRates} component={ADM_PayRates} />,
    <PrivateRoute
      key={routes.admin.agents.serviceProviders}
      path={routes.admin.agents.serviceProviders}
      component={ADM_SERVICE_PROVIDERS}
    />,
    <PrivateRoute
      key={routes.admin.agents.fraudReviewGroups}
      path={routes.admin.agents.fraudReviewGroups}
      component={ADM_FRAUD_REVIEW_GROUPS}
    />,
    <PrivateRoute
      key={routes.admin.refer.payRates}
      path={routes.admin.refer.payRates}
      component={ADM_GigCampaignPage}
    />,
    <PrivateRoute
      key={routes.admin.refer.featuredGigs}
      path={routes.admin.refer.featuredGigs}
      component={ADM_FeaturedGigsPage}
    />,
  ];
  getCommonRoutes().forEach(item => items.push(item));
  return items;
};
